import { render, staticRenderFns } from "./MatchPotentialAddOccupationModal.vue?vue&type=template&id=3535e235&scoped=true&"
import script from "./MatchPotentialAddOccupationModal.vue?vue&type=script&lang=js&"
export * from "./MatchPotentialAddOccupationModal.vue?vue&type=script&lang=js&"
import style0 from "./MatchPotentialAddOccupationModal.vue?vue&type=style&index=0&id=3535e235&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3535e235",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormAutocomplete: require('/workspace/components/Form/FormAutocomplete.vue').default,FormSelect: require('/workspace/components/Form/FormSelect.vue').default})
